const millisecondsInSecond = 1000;
const renewBeforeExpiration = 30 * millisecondsInSecond;
const maxDelay = 2147483647;
export class TokenReader {
    constructor(currentSiteId, clock) {
        this.currentSiteId = currentSiteId.toString();
        this.clock = clock;
    }
    isAnonymous(token) {
        const payload = this.getTokenPayload(token);
        return !payload.PlayerId;
    }
    isValid(token) {
        if (token) {
            try {
                const tokenPayload = this.getTokenPayload(token);
                return this.isFromCurrentSite(tokenPayload) && this.isNotExpired(tokenPayload);
            }
            catch (e) {
                console.warn(e);
            }
        }
        return false;
    }
    isFromCurrentSite(tokenPayload) {
        return tokenPayload.SiteId.toString() === this.currentSiteId;
    }
    isNotExpired(tokenPayload) {
        return this.getExpirationDateFromPayload(tokenPayload) > this.clock.now();
    }
    getTokenPayload(token) {
        const tokenSections = token.split(".");
        if (tokenSections.length === 3) {
            return JSON.parse(atob(tokenSections[1].replace(/-/g, "+").replace(/_/g, "/")));
        }
        throw new Error(`Token has not valid format "${token}"`);
    }
    getExpirationDate(token) {
        return this.getExpirationDateFromPayload(this.getTokenPayload(token));
    }
    getIntervalForRenew(token) {
        const expirationDate = this.getExpirationDate(token);
        const msUntilExpiration = expirationDate.getTime() - this.clock.now().getTime();
        const delay = msUntilExpiration - renewBeforeExpiration;
        if (delay <= 0) {
            return 0;
        }
        return (delay <= maxDelay) ? delay : maxDelay;
    }
    getExpirationDateFromPayload(tokenPayload) {
        return new Date(tokenPayload.exp * millisecondsInSecond);
    }
}
//# sourceMappingURL=TokenReader.js.map